export const FETCH_TESTIMONIALS_LIST = "FETCH_TESTIMONIALS_LIST";
export const FETCH_TESTIMONIALS_LIST_SUCCESS =
  "FETCH_TESTIMONIALS_LIST_SUCCESS";
export const FETCH_TESTIMONIALS_LIST_FAILED = "FETCH_TESTIMONIALS_LIST_FAILED";

export const FETCH_TESTIMONIALS_DETAILS = "FETCH_TESTIMONIALS_DETAILS";
export const FETCH_TESTIMONIALS_DETAILS_SUCCESS =
  "FETCH_TESTIMONIALS_DETAILS_SUCCESS";
export const FETCH_TESTIMONIALS_DETAILS_FAILED =
  "FETCH_TESTIMONIALS_DETAILS_FAILED";

export const FETCH_STATE = "FETCH_STATE";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";
export const FETCH_STATE_FAILED = "FETCH_STATE_FAILED";

export const FETCH_CITY = "FETCH_CITY";
export const FETCH_CITY_SUCCESS = "FETCH_CITY_SUCCESS";
export const FETCH_CITY_FAILED = "FETCH_CITY_FAILED";

export const CREATE_TESTIMONIAL = "CREATE_TESTIMONIAL";
export const CREATE_TESTIMONIAL_SUCCESS = "CREATE_TESTIMONIAL_SUCCESS";
export const CREATE_TESTIMONIAL_FAILED = "CREATE_TESTIMONIAL_FAILED";

export const UPDATE_TESTIMONIAL = "UPDATE_TESTIMONIAL";
export const UPDATE_TESTIMONIAL_SUCCESS = "UPDATE_TESTIMONIAL_SUCCESS";
export const UPDATE_TESTIMONIAL_FAILED = "UPDATE_TESTIMONIAL_FAILED";

export const UPLOAD_URL = "UPLOAD_URL";
export const UPLOAD_URL_SUCCESS = "UPLOAD_URL_SUCCESS";
export const UPLOAD_URL_FAILED = "UPLOAD_URL_FAILED";

export const READ_URL = "READ_URL";
export const READ_URL_SUCCESS = "READ_URL_SUCCESS";
export const READ_URL_FAILED = "READ_URL_FAILED";

export const UPLOAD_BINARY_URL = "UPLOAD_BINARY_URL";
export const UPLOAD_BINARY_URL_SUCCESS = "UPLOAD_BINARY_URL_SUCCESS";
export const UPLOAD_BINARY_URL_FAILED = "UPLOAD_BINARY_URL_FAILED";

export const TESTIMONIAL_UPDATE_DETAILS = "TESTIMONIAL_UPDATE_DETAILS";
export const TESTIMONIAL_UPDATE_DETAILS_SUCCESS = "TESTIMONIAL_UPDATE_DETAILS_SUCCESS";
export const TESTIMONIAL_UPDATE_DETAILS_FAILED = "TESTIMONIAL_UPDATE_DETAILS_FAILED";


export const CLEAR_PREVIOUS_REDUCERS = "CLEAR_PREVIOUS_REDUCERS";
